import PropTypes from 'prop-types';
var propTypes = {
  clearButton: PropTypes.bool,
  customStyle: PropTypes.any,
  colorScheme: PropTypes.oneOf(['bronze', 'chartreuse', 'cornFlowerBlue', 'darkNavy', 'darkOrange', 'fuchsia', 'gold', 'gray', 'green', 'hotPink', 'hpBlue', 'hunterGreen', 'lavender', 'lime', 'maroon', 'mediumOrchid', 'red', 'royalBlue', 'salmon', 'tangerine', 'vividSkyBlue', 'warmGray']),
  disabled: PropTypes.bool,
  i18n: PropTypes.shape({
    close: PropTypes.string.isRequired
  }),
  isTint: PropTypes.bool,
  label: PropTypes.string.isRequired,
  leadingIcon: PropTypes.element,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onBlur: PropTypes.func,
  onClose: PropTypes.func,
  onFocus: PropTypes.func
};
export default propTypes;